export default "__VITE_ASSET__DtRztSf1__"